var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkup)?_c('div',{staticClass:"checkup"},[(_vm.checkup.deviceType === 'T8X')?_c('T8x',{attrs:{"checkup":_vm.checkup}}):_c('Gs2',{attrs:{"checkup":_vm.checkup}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }